import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import { withTranslation } from 'react-i18next';
import NavLink from './NavLink';

import { VERIFY_AUTHORIZATION } from '../../../../Admin/Util/userType_constants';
import { getNavigationalWindowObject } from '../../../../AppUtil/AppUtil';
import Session from '../../../../Service/Session';
import { hot } from 'react-hot-loader';

const EXTERNAL_LINK = window.AppConfig.SUPPORT_URLS;
const USER_TYPE = window.AppConfig.USER_TYPES;

const drawerWidth = 240;
const styles = theme => ({
	drawer: {
		width: drawerWidth,
		flexShrink: 0
	},
	drawerPaper: {
		width: drawerWidth
	},
	drawerHeader: {
		display: 'flex',
		alignItems: 'center',
		padding: theme.spacing(0, 1),
		...theme.mixins.toolbar,
		justifyContent: 'flex-end'
	}
});

const clearLoanObject = () => {
	if (!getNavigationalWindowObject()) {
		Session.remove('LOAN_OBJECT');
	}
};

class SideNav extends React.Component {
	openScreen = screen => {
		
		clearLoanObject();
		this.props.openScreen(screen);

		this.props.closeSideNav();
	};

	onTargetBlankScreen = link => {
		window.open(link, '_blank');
		this.props.closeSideNav();
	};

	render() {
		const theme = this.props;
		const { t, classes } = this.props;
		const current_user_info = Session.get('CURRENT_USER_INFO');

		const { isSUPER_ADMIN, isACCOUNTING, isCOMMERCIAL, isCUSTOMER_SERVICE, isADMIN } =
			VERIFY_AUTHORIZATION(current_user_info);
		const hasAccessToAdmin = isSUPER_ADMIN || isACCOUNTING || isCUSTOMER_SERVICE || isCOMMERCIAL || isADMIN;

		return (
			<Drawer
				anchor="left"
				classes={{
					paper: classes.drawerPaper
				}}
				className={classes.drawer}
				open={this.props.isSideNavOpen}
				variant="persistent">
				{/* <div className={classes.drawerHeader}> */}
				<div style={{ backgroundColor: '', height: '43px', display: 'flex', justifyContent: 'right' }}>
					<IconButton onClick={this.props.closeSideNav} style={{ outline: 'none' }}>
						{/* {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />} */}
						<img width={22} height={22} src={process.env.PUBLIC_URL + 'images/x-default.svg'} />
					</IconButton>
				</div>
				<Divider />
				<List>
					<NavLink
						name={t('start_a_loan').toUpperCase()}
						onClick={() => {
							this.openScreen('HOME');
						}}
					/>
					<NavLink
						name={'loan calculator'.toUpperCase()}
						onClick={() => {
							this.openScreen('LOAN_CALCULATOR');
						}}
					/>
					{this.props.currentUser ? (
						' '
					) : (
						<NavLink
							name={'LOG IN'}
							onClick={() => {
								
								this.openScreen('AUTH');
							}}
						/>
					)}
					{!this.props.currentUser ? (
						' '
					) : (
						<NavLink
							// name={t('loan_list').toUpperCase()}
							name="DASHBOARD"
							onClick={() => {
								this.openScreen('LOAN_LIST');
							}}
						/>
					)}
					{!this.props.currentUser ? (
						' '
					) : (
						<NavLink
							name={t('profile').toUpperCase()}
							onClick={() => {
								this.openScreen('PROFILE');
							}}
						/>
					)}
					<NavLink
						name={t('how_it_works').toUpperCase()}
						onClick={() => {
							this.onTargetBlankScreen(EXTERNAL_LINK.HOW_IT_WORK);
						}}
					/>
					<NavLink
						name={t('help').toUpperCase()}
						onClick={() => {
							this.onTargetBlankScreen(EXTERNAL_LINK.LENDAMI_CONTACT);
						}}
					/>
					<NavLink
						name={t('terms_of_user').toUpperCase()}
						onClick={() => {
							this.onTargetBlankScreen(t('terms_link'));
						}}
					/>
					<NavLink
						name={t('privacy_policy').toUpperCase()}
						onClick={() => {
							this.onTargetBlankScreen(t('privacy_link'));
						}}
					/>

					{hasAccessToAdmin ? (
						<NavLink
							name={t('admin').toUpperCase()}
							onClick={() => {
								window.location.href = '/admin';
							}}
						/>
					) : (
						''
					)}
					{!this.props.currentUser ? (
						' '
					) : (
						<NavLink
							name={'LOGOUT'}
							onClick={() => {
								window.location.href = '/logout';
							}}
						/>
					)}
				</List>
				<Divider />
			</Drawer>
		);
	}
}

export default hot(module)(withTranslation(['Nav'])(withStyles(styles)(SideNav)));
